import script from "./OkrTimelinesBacklogError.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrTimelinesBacklogError.vue?vue&type=script&setup=true&lang=js"

import "./OkrTimelinesBacklogError.vue?vue&type=style&index=0&id=74f8fe69&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f8fe69"]])

export default __exports__